<template>
  <!-- 機器予約 -->
  <div id="HolterDevicePreparationDetail">
    <div id="container">
      <div class="labelTitle lable">ホルター心電図配送ｻｰﾋﾞｽ 機器予約</div>
      <div class="button-area"><b-button class="backButton is-primary" v-on:click="back">戻る</b-button></div>
      <div id="item-contens">
        <div class="card-content margin-top">
          <table>
            <tr>
              <th>受付番号</th>
              <td><a @click="showDetail(data.receiptNumber)">{{data.receiptNumber}} <b-icon icon="vector-arrange-above"/></a><span v-if="data.depo" class="depo"/></td>
            </tr>
            <tr>
              <th>医療機関名</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.hospital}}</td>
            </tr>
            <tr>
              <th>発送先</th>
              <td v-if="data.delivaryTarget == 'home'">患者宅</td>
              <td v-if="data.delivaryTarget == 'hospital'">医療機関</td>
            </tr>
            <tr>
              <th>出荷予定日</th>
              <td>{{data.shippingDate}}</td>
            </tr>
            <tr>
              <th>WP300同梱の有無</th>
              <td><span v-if="data.hstRequestFlag">有</span><span v-else>無</span></td>
            </tr>
            <tr>
              <th style="vertical-align:top;">患者備考</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patientNote}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">配送備考</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.deliveryInformationNote}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">受付備考</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.receptionNote}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">外部ユーザーコメント</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.belongsNote}}</td>
            </tr>
          </table>
        </div>
        <template v-for="(deviceInfo, index) in data.deviceInfoList">
          <div class="card-content margin-top" :key="index">
          <span style="font-size:20px;">機器情報{{index+1}}</span>
          <table>
            <tr>
              <th>機種</th>
              <td>{{deviceInfo.instrumentKind}}</td>
            </tr>
            <tr>
              <th>検査期間
              </th>
              <td>{{data.inspectionPeriod | getNameFilter(inspectionPeriodList)}}</td>
            </tr>
            <tr>
              <th>解析オプション</th>
              <td>{{data.analysisOption | getNameFilter(analysisOptionList)}}</td>
            </tr>
            <tr>
              <th>シリアルナンバー<span class="require"/></th>
              <td style="width:350px;"><input type="text" :id="'serial' + index" v-model="deviceInfo.serial" :disabled="deviceInfo.status!=2" @keyup.enter="onKeyupEnter(deviceInfo, index)" @focus="isButtonDisable=true" @input="isButtonDisable=true" @blur="focusLost(deviceInfo)"/></td>
              <td>
                <span class="error" v-if="deviceInfo.status==2 && (!deviceInfo.serial && !deviceInfo.leaseupDate)" style="margin-left:10px;">該当する機器が存在しません。</span>
                <span v-else-if="(deviceInfo.status!=2&&deviceInfo.reserveTime) || deviceInfo.leaseupDate" style="margin-left:10px;">リースアップ日：{{deviceInfo.leaseupDate}}、機器予約コード：{{deviceInfo.reserveTime}}</span>
                <span v-else style="margin-left:10px;"><span v-if="deviceInfo.leaseupDate">リースアップ日：{{deviceInfo.leaseupDate}}、</span>機器予約コード：{{deviceInfo.reserveTime}}</span>
              </td>
            </tr>
            <tr>
              <th>パッチのロット1<span class="require"/></th>
              <td style="width:350px;"><input type="text" :id="'patchlot1' + index" v-model="deviceInfo.patchlot1" :disabled="deviceInfo.status!=2" @keyup.enter="onKeyupEnterPatchlot1(deviceInfo, index)" @focus="isButtonDisable=true" @input="isButtonDisable=true" @blur="isButtonDisable=false"/></td>
            </tr>
            <tr>
              <th>パッチのロット2<span v-if="data.inspectionPeriod=='3' || data.inspectionPeriod=='4'" class="require"/></th>
              <td style="width:350px;"><input type="text" :id="'patchlot2' + index" v-model="deviceInfo.patchlot2" :disabled="deviceInfo.status!=2 || (data.inspectionPeriod=='1' || data.inspectionPeriod=='2')" @keyup.enter="onKeyupEnterPatchlot2(deviceInfo, index)" @focus="isButtonDisable=true" @input="isButtonDisable=true" @blur="isButtonDisable=false"/></td>
            </tr>
            <tr>
              <th>パッチのロット3<span v-if="data.inspectionPeriod=='4'" class="require"/></th>
              <td style="width:350px;"><input type="text" :id="'patchlot3' + index" v-model="deviceInfo.patchlot3" :disabled="deviceInfo.status!=2 || (data.inspectionPeriod=='1' || data.inspectionPeriod=='2' || data.inspectionPeriod=='3')" @keyup.enter="onKeyupEnterPatchlot3(deviceInfo, index)" @focus="isButtonDisable=true" @input="isButtonDisable=true" @blur="isButtonDisable=false"/></td>
            </tr>
            <template v-if="!atLaunchHidden.hiddenFlag">
              <tr v-if="data.delivaryTarget == 'hospital' && data.leadWireAdapter == true">
                <th>リードワイヤーアダプター</th>
                <td style="width:350px;"><input type="text" :id="'leadPatch' + index" v-model="deviceInfo.leadPatch" :disabled="deviceInfo.status!=2" @keyup.enter="onKeyupEnterLeadPatch(deviceInfo, index)" @focus="isButtonDisable=true" @input="isButtonDisable=true" @blur="isButtonDisable=false"/></td>
              </tr>
              <tr v-else>
                <th>リードワイヤーアダプター</th>
                <td style="width:350px;"><input type="text" :id="'leadPatch' + index" disabled/></td>
              </tr>
            </template>
            <tr>
              <th>患者名</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{deviceInfo.patientName}}</td>
            </tr>
            <tr v-if="data.delivaryTarget == 'hospital' && !atLaunchHidden.hiddenFlag">
              <th>リードワイヤーアダプター</th>
              <td><span v-if="data.leadWireAdapter">必要</span><span v-else>不要</span></td>
            </tr>
          </table>
        </div>
        </template>
        <div class="button-area">
          <b-button class="receptionistButton is-primary" @click="receptionist" :disabled="isButtonDisable">機器予約</b-button>
          <b-button class="backButton is-primary" @click="back">戻る</b-button>
        </div>
      </div>
    </div>
    <floatingDiv v-if="isShowDetail" @close="closeDetail" title="" width="640px" height="480px" top="100px" right="100px">
      <holterRequestDetail v-bind:data="data.applicationDetails"/>
    </floatingDiv>
  </div>
</template>

<script>
import floatingDiv from "@/components/mock/common/FloatingDiv";
import HolterRequestDetail from "@/components/mock/common/HolterRequestDetail";
import {choicesType} from "@/components/mock/base/const.js";
import {atLaunchHidden} from "@/components/mock/base/const.js";

export default {
  name: "HolterDevicePreparationDetail",
  methods: {
    back: function () {
      this.$router.push({
        name: "HolterDevicePreparation",
        params: { searchConditions: this.searchParams },
      });
    },
    isDuplicateSerial: function() {
      // シリアルの重複チェック
      const serialList = []
      this.data.deviceInfoList.map((item) => {
        if(item.serial){
          serialList.push(item.serial)
        }
      });
      const setElements = new Set(serialList);
      if (setElements.size !== serialList.length) {
        return true
      }
      return false
    },
    receptionist: function() {
      this.receptionistData = this.data.deviceInfoList.filter(val => val.serial && val.status==2 && val.reserveTime)
      if(this.receptionistData.length==0){
        this.showErrorMessage("正しいシリアル番号が入力されていません。")
        return
      }
      if(this.isDuplicateSerial()){
        this.showErrorMessage("重複しているシリアル番号があります。")
        return
      }
      for(let i = 0; i < this.receptionistData.length; i++){
        if(!this.receptionistData[i].patchlot1){
          this.showErrorMessage("パッチ1が入力されていません。")
          return
        }
        if(!this.receptionistData[i].patchlot2 && (this.data.inspectionPeriod=='3' || this.data.inspectionPeriod=='4')){
          this.showErrorMessage("パッチ2が入力されていません。")
          return
        }
        if(!this.receptionistData[i].patchlot3 && this.data.inspectionPeriod=='4'){
          this.showErrorMessage("パッチ3が入力されていません。")
          return
        }
      }
      // 機器予約
      var excuteApi = this.setHolterDeviceReservePOST;
      var successCallBack = this.setHolterDeviceReservePOSTSuccess;
      var errorCallBack = this.setHolterDeviceReservePOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setHolterDeviceReservePOST: function(client) {
      return client.apis.internalHolter.setHolterDeviceReservePOST({
        body:this.receptionistData
      });
    },
    setHolterDeviceReservePOSTSuccess: function(result) {
      this.showSuccess(result,this.back());
    },
    setHolterDeviceReservePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    showDetail: function(id) {
      this.isShowDetail = true;
    },
    closeDetail: function(){
      this.isShowDetail = false;
    },
    doSearch: function() {
      var excuteApi = this.getHolterDevicePreparationDetailPOST;
      var successCallBack = this.getHolterDevicePreparationDetailPOSTSuccess;
      var errorCallBack = this.getHolterDevicePreparationDetailPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getHolterDevicePreparationDetailPOST: function(client) {
      return client.apis.internalHolter.getHolterDevicePreparationDetailPOST({
        body:{receiptNumber:this.targetNumber}
      });
    },
    getHolterDevicePreparationDetailPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
    },
    getHolterDevicePreparationDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result,this.back());
    },
    onKeyupEnter: function(rowItem, index){
      if(!rowItem.serial){
        return
      }
      //シリアルを取得
      let serialItems = rowItem.serial.split('/');
      if(serialItems.length == 2){
        //　"/"が含まれていたらそれ以降の文字に変更する
        rowItem.serial = serialItems[1]
      }
      if(rowItem.serial){
        var nextElement = document.getElementById("patchlot1" + (index));
        if(nextElement){
          // 次のアイテムが存在する場合、フォーカスを移動
          this.focusTarget = nextElement
          nextElement.focus();
        }else{
          // 次のアイテムが存在しない場合、フォーカスを外す
          let element = document.getElementById("patchlot1" + (index));
          element.blur();
        }
      }
    },
    onKeyupEnterPatchlot1: function(rowItem, index){
      if(!rowItem.patchlot1){
        return
      }
      //パッチのロット1を取得
      let patchlot1Items = rowItem.patchlot1.split('/');
      if(patchlot1Items.length == 2){
        //　"/"が含まれていたらそれ以降の文字に変更する
        rowItem.patchlot1 = patchlot1Items[1]
      }
      if(rowItem.patchlot1){
        var nextElement = document.getElementById("patchlot2" + (index));
        if(nextElement){
          // 次のアイテムが存在する場合、フォーカスを移動
          this.focusTarget = nextElement
          nextElement.focus();
        }else{
          // 次のアイテムが存在しない場合、フォーカスを外す
          let element = document.getElementById("patchlot1" + (index));
          element.blur();
        }
      }
    },
    onKeyupEnterPatchlot2: function(rowItem, index){
      if(!rowItem.patchlot2){
        return
      }
      //パッチのロット2を取得
      let patchlot2Items = rowItem.patchlot2.split('/');
      if(patchlot2Items.length == 2){
        //　"/"が含まれていたらそれ以降の文字に変更する
        rowItem.patchlot2 = patchlot2Items[1]
      }
      if(rowItem.patchlot2){
        var nextElement = document.getElementById("leadPatch" + (index));
        if(nextElement){
          if(nextElement.disabled){
            // 次のアイテムが非活性の場合、さらに次のアイテム(シリアルナンバー)が存在する場合、フォーカス移動
            var nextNextElement = document.getElementById("serial" + (index + 1));
            if (nextNextElement){
              this.focusTarget = nextNextElement
              nextNextElement.focus();
            }else{
              let element = document.getElementById("patchlot2" + (index));
              element.blur();
            }
          }else{
            // 次のアイテムが存在する場合、フォーカスを移動
            this.focusTarget = nextElement
            nextElement.focus();
          }
        }else{
          // 次のアイテムが非活性の場合、さらに次のアイテム(シリアルナンバー)が存在する場合、フォーカス移動
          var nextNextElement = document.getElementById("serial" + (index + 1));
          if (nextNextElement){
            this.focusTarget = nextNextElement
            nextNextElement.focus();
          }else{
            let element = document.getElementById("patchlot2" + (index));
            element.blur();
          }
        }
      }
    },
    onKeyupEnterPatchlot3: function(rowItem, index){
      if(!rowItem.patchlot3){
        return
      }
      //パッチのロット3を取得
      let patchlot3Items = rowItem.patchlot3.split('/');
      if(patchlot3Items.length == 2){
        //　"/"が含まれていたらそれ以降の文字に変更する
        rowItem.patchlot3 = patchlot3Items[1]
      }
      if(rowItem.patchlot3){
        var nextElement = document.getElementById("leadPatch" + (index));
        if(nextElement){
          if(nextElement.disabled){
            // 次のアイテムが非活性の場合、さらに次のアイテム(シリアルナンバー)が存在する場合、フォーカス移動
            var nextNextElement = document.getElementById("serial" + (index + 1));
            if (nextNextElement){
              this.focusTarget = nextNextElement
              nextNextElement.focus();
            }else{
              let element = document.getElementById("patchlot3" + (index));
              element.blur();
            }
          }else{
            // 次のアイテムが存在する場合、フォーカスを移動
            this.focusTarget = nextElement
            nextElement.focus();
          }
        }else{
          // 次のアイテムが非活性の場合、さらに次のアイテム(シリアルナンバー)が存在する場合、フォーカス移動
          var nextNextElement = document.getElementById("serial" + (index + 1));
          if (nextNextElement){
            this.focusTarget = nextNextElement
            nextNextElement.focus();
          }else{
            let element = document.getElementById("patchlot3" + (index));
            element.blur();
          }
        }
      }
    },
    onKeyupEnterLeadPatch: function(rowItem, index){
      if(!rowItem.leadPatch){
        return
      }
      //リードワイヤーアダプターを取得
      let leadPatchItems = rowItem.leadPatch.split('/');
      if(leadPatchItems.length == 2){
        //　"/"が含まれていたらそれ以降の文字に変更する
        rowItem.leadPatch = leadPatchItems[1]
      }
      if(rowItem.leadPatch){
        var nextElement = document.getElementById("serial" + (index + 1));
        if(nextElement){
          // 次のアイテムが存在する場合、フォーカスを移動
          this.focusTarget = nextElement
          nextElement.focus();
        }else{
          // 次のアイテムが存在しない場合、フォーカスを外す
          let element = document.getElementById("leadPatch" + (index));
          element.blur();
        }
      }
    },
    focusLost: async function (rowItem) {
      this.searchTarget = rowItem
      if(rowItem.serial){
        var excuteApi = this.getMachineDetailPOST;
        var successCallBack = this.getMachineDetailPOSTSuccess;
        var errorCallBack = this.getMachineDetailPOSTError;
        // WebAPI Call
        await this.apiCall(excuteApi, successCallBack, errorCallBack);
      }else{
        this.isButtonDisable = false
        this.$set(this.searchTarget,"leaseupDate","")
        this.$set(this.searchTarget,"reserveTime","")
      }
    },
    getMachineDetailPOST: function(client) {
      return client.apis.apiCommon.getMachineDetailPOST({ 
        body: {
          serial:this.searchTarget.serial,
          modelId:this.searchTarget.modelId
        } 
      });
    },
    getMachineDetailPOSTSuccess: function(result) {
      var machineDetail = result.obj;
      if(this.isPastday(machineDetail.leaseupDate)){
        // リースアップ日を超えている場合は、警告メッセージ
        var messsge = machineDetail.leaseupDate + "にリースアップ日を超過している機器です。";
        this.$dialog.alert({
          title: '　',
          message: messsge,
        })
        this.$set(this.searchTarget,"serial","")
      }else if(this.isSoon(machineDetail.leaseupDate,2)){
        // リースアップ日が2ヶ月以内の場合近づいている場合は、警告メッセージ
        var messsge = machineDetail.leaseupDate + "にリースアップする機器です。";
        this.$dialog.alert({
          title: '　',
          message: messsge,
        })
        this.$set(this.searchTarget,"serial","")
      }else{
        // リースアップ日をセット
        this.$set(this.searchTarget,"leaseupDate",machineDetail.leaseupDate)
        // 機器予約コードをセット
        this.$set(this.searchTarget,"reserveTime",new Date().getTime())
      }
      this.isButtonDisable = false
    },
    getMachineDetailPOSTError: function(result) {
      // シリアルに一致する利用可能な機器が存在しない場合
      this.$set(this.searchTarget,"serial","")
      this.$set(this.searchTarget,"leaseupDate","")
      this.$set(this.searchTarget,"reserveTime","")
      this.showErrorMessage(result);
      this.isButtonDisable = false
    }
  },
  data() {
    var targetNumber = this.$route.params["receiptNumber"];
    var searchParams = this.$route.params["searchConditions"];
    var beltSizeList = this.getChoiceList(choicesType.beltSize, false);
    let analysisOptionList = this.getChoiceList(choicesType.holterAnalysisOp, true);
    let inspectionPeriodList = this.getChoiceList(choicesType.holterInspectionPeriod, true);
    beltSizeList.unshift({})
    return {
      data: {},
      targetNumber,
      searchParams,
      isShowDetail: false,
      searchTarget:{},
      receptionistData:[],
      beltSizeList,
      isButtonDisable:false,
      analysisOptionList: analysisOptionList,
      inspectionPeriodList: inspectionPeriodList,
      atLaunchHidden: atLaunchHidden
    };
  },
  filters: {
    getNameFilter: function(val, list){
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    }
  },
  async mounted() {
    // 詳細情報取得
    await this.doSearch();
  },
  components: { 
    floatingDiv: floatingDiv,
    holterRequestDetail:HolterRequestDetail
  }
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
table.flowTable,
table.flowTable tr,
table.flowTable td {
    border: 1px solid;
    padding: 0px;
    vertical-align: middle;
}
table.flowTable td {
    width: 40px;
    text-align: center;
}

.delay {
    font-weight: bold; 
}
.delay ,
.error {
    color: red;
    margin-left:5px;
}

</style>


// WEBPACK FOOTER //
// src/components/mock/philips/holter/HolterDevicePreparationDetail.vue